namespace $ {
	const { rem } = $mol_style_unit
	$mol_style_define($exso_sheets_login, {
		Body: {
			flexDirection: 'column',
			display: 'flex',
			background: { color: $mol_theme.card },
		},
		Body_content: {
			flex: { grow: 1 },
			width: '100%',
			alignItems: 'center',
			justifyContent: 'center',
		},
		Form: {
			background: { color: $mol_theme.back },
			padding: $mol_gap.space,
			border: { radius: $mol_gap.block, color: $mol_theme.line, width: '1px', style: 'solid' },
		},
		Head: { border: { style: 'none' } },
		Title: {
			font: { weight: 'bold' },
			justifyContent: 'center',
			fontSize: rem(1.2),
		},
		Submit: {
			flex: { grow: 1 },
			justifyContent: 'center',
		},
	})
}
